import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Duration from "./images/duration.png";
import { useTheme } from "../../contexts/ThemeContext";

const COLORS = [
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#AF19FF",
  "#FF6666",
  "#66FF66",
  "#6699FF",
  "#FF33CC",
  "#FF9933",
];

const MostAskedThemes = ({ data, startDate, endDate }) => {
  const [showIcon, setShowIcon] = useState(false);
  const { theme } = useTheme();
  useEffect(() => {
    if (!startDate || !endDate) {
      setShowIcon(false);
      return;
    }

    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const isDefaultStart =
      startDate.getFullYear() === firstDayOfMonth.getFullYear() &&
      startDate.getMonth() === firstDayOfMonth.getMonth() &&
      startDate.getDate() === firstDayOfMonth.getDate();

    const isDefaultEnd =
      endDate.getFullYear() === today.getFullYear() &&
      endDate.getMonth() === today.getMonth() &&
      endDate.getDate() === today.getDate();

    setShowIcon(!(isDefaultStart && isDefaultEnd));
  }, [startDate, endDate]);

  const themeList = data?.mostAskedThemes;

  if (!Array.isArray(themeList) || themeList.length === 0) {
    return (
      <div 
        className="w-full p-4 rounded-2xl shadow flex items-center justify-center no-data"
        style={{
          backgroundColor: theme.colors.surface,
          border: `1px solid ${theme.colors.border}`,
          color: theme.colors.textSecondary
        }}
      >
        <p style={{ color: theme.colors.textSecondary }}>No theme data available</p>
      </div>
    );
  }

  const formattedData = themeList.map((item) => ({
    name: item.theme.replace(/_/g, " "),
    value: item.count,
  }));

  const renderCustomLegend = (props) => {
    const { payload } = props;

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <div className="legend-grid">
          {payload.map((entry, index) => (
            <div
              key={`legend-${index}`}
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <div
                style={{
                  width: 12,
                  height: 12,
                  backgroundColor: entry.color,
                  borderRadius: "50%",
                  flexShrink: 0,
                }}
              />
              <span style={{ color: theme.colors.text }}>{entry.value}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div 
      className="w-full h-[350px] p-4 rounded-2xl shadow"
      style={{
        backgroundColor: theme.colors.surface,
        border: `1px solid ${theme.colors.border}`,
        color: theme.colors.text
      }}
    >
      <h3 style={{ color: theme.colors.text }}>Most Asked Themes</h3>
      {showIcon && (
        <img src={Duration} alt="duration" className="duration-icon" />
      )}
      <ResponsiveContainer
        width="100%"
        height={460}
        style={{ fontSize: "0.8rem" }}
      >
        <PieChart>
          <Pie
            data={formattedData}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={100}
            paddingAngle={2}
            dataKey="value"
          >
            {formattedData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip />
          <Legend content={renderCustomLegend} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MostAskedThemes;
